import { Add } from '@mui/icons-material'
import { Box, Button, Grid, MenuItem, Paper, Select, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import Dashboard from '../../components/Layouts/dashboardLayout'
// import StatusCard from "../MyBookings/components/StatusCard";
import CardContainer from './components/Card'
import { BookingStatusOptions } from './helper'
import useBookings from './hooks/useBookings'
import LinearProgress from '@mui/material/LinearProgress'
import { useMobile } from '../../hooks/useMoblie'

const MyBookings2 = () => {
    const { form, bookings, handleCreateBooking, loading } = useBookings()
    const isMobile = useMobile()
    return (
        <Dashboard>
            <form onSubmit={form.handleSubmit}>
                <Paper
                    sx={{
                        p: 2,
                    }}
                >
                    <Stack direction={isMobile ? 'column' : 'row'} justifyContent="space-between" spacing={2}>
                        <Stack direction={isMobile ? 'column' : 'row'} spacing={2}>
                            <Select
                                sx={{
                                    minWidth: 250,
                                }}
                                name="status"
                                value={form.values.status}
                                onChange={form.handleChange}
                            >
                                {BookingStatusOptions.map((option) => {
                                    return (
                                        <MenuItem value={option.value} key={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                            <TextField
                                name="bookingId"
                                label="Booking ID"
                                sx={{ mr: 2 }}
                                onChange={form.handleChange}
                                value={form.values.bookingId}
                            />
                            <Button variant="contained" type="submit">
                                Search
                            </Button>
                        </Stack>

                        <Button variant="contained" onClick={handleCreateBooking}>
                            <Add fontSize="medium" /> Create Booking
                        </Button>
                    </Stack>
                </Paper>
            </form>
            {loading && (
                <Box sx={{ width: '50%', margin: '35vh auto' }}>
                    <LinearProgress />
                </Box>
            )}
            {!loading &&
                (bookings.length === 0 ? (
                    <Box sx={{ width: '50%', margin: '35vh auto' }}>
                        <Typography variant="h5" align="center" color="#747474">
                            No Bookings Found
                        </Typography>
                    </Box>
                ) : (
                    <Grid container alignItems="stretch" spacing={1.5} mt>
                        {bookings.map((item, index) => {
                            if (item.legacyBooking) {
                                return <></>
                            } else {
                                return (
                                    <Grid
                                        key={index}
                                        style={{ display: 'flex' }}
                                        // key={bookingData.bookingId}
                                        item
                                        xs={12}
                                        lg={4}
                                        md={6}
                                    >
                                        <CardContainer item={item} />
                                    </Grid>
                                )
                            }
                        })}
                    </Grid>
                ))}
        </Dashboard>
    )
}

export default MyBookings2
